<template>
    <div class="empty-hero">
        <div class="hero-inner">
            <i :class="['fad', icon, 'hero-icon']"></i>
            <div class="hero-title" v-if="title">{{ title }}</div>
            <div class="hero-text" v-if="text">{{ text }}</div>
            <div class="hero-actions" v-if="$slots.default"><slot/></div>
        </div>
    </div>
</template>

<script>
    // Full-panel empty state: a large icon with title, copy and a couple of
    // buttons, centered both ways in the content area. For pages whose whole
    // purpose is a list that happens to be empty (Current Enrollments).
    export default {
        name: "EmptyHero",
        props: {
            icon: {type: String, default: 'fa-circle-info'},
            title: {type: String, default: null},
            text: {type: String, default: null},
        }
    };
</script>

<style lang="scss" scoped>
    .empty-hero {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 60vh;
        padding: 2rem 1rem;
        color: white;
        text-align: center;
    }

    .hero-inner {
        max-width: 42rem;
    }

    .hero-icon {
        font-size: 4.5rem;
        color: rgba(255, 255, 255, 0.85);
        margin-bottom: 1.25rem;
    }

    .hero-title {
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1.25;
    }

    .hero-text {
        margin-top: 0.6rem;
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.8);
        line-height: 1.5;
    }

    .hero-actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 0.75rem;
        margin-top: 1.75rem;
    }
</style>
